// The country prefix is displayed separately. Never shift a complete mobile
// number when an extra digit is typed or pasted into the national-number box.
export function formatOrderPhoneInput(input, previousValue = '') {
  const raw = String(input ?? '').trim();
  let digits = raw.replace(/\D/g, '');
  if (/^\+91/.test(raw)) digits = digits.slice(2);
  if (digits.length > 10) return previousValue;
  const national = digits.length > 5
    ? `${digits.slice(0, 5)} ${digits.slice(5)}`
    : digits;
  return national ? `+91 ${national}` : '+91';
}
